const flutterMountedMixin = {
    async mounted() {
        await this.$nextTick();
        window.app.notifyFlutterMounted();
    },
};

export default flutterMountedMixin;
